import axios from 'axios'
import { handleSuccess, handleError } from './axiosHandler';
import { authHeader, authHeaderJson } from '../_helpers/auth-header';

import  config  from '../config';
const base_url = config.apiUrl;

const model = 'Banks/';

export const banksService = {
  getAll,
  getById,
  add,
  edit,
  delete: _delete
};

function getAll() {
  const url = base_url + model;
  axios.interceptors.response.use(handleSuccess, handleError);
  return axios.get(url, { headers: authHeader()});
}

function getById(id) {
  const url = base_url + model + id;
  axios.interceptors.response.use(handleSuccess, handleError);
  return axios.get(url, { headers: authHeader()});
}

function add(form) {
  const url = base_url + model;
  axios.interceptors.response.use(handleSuccess, handleError);
  return axios.post(url, form, { headers: authHeaderJson()});
}

function edit(id, form) {
  const url = base_url + model + id;
  axios.interceptors.response.use(handleSuccess, handleError);
  return axios.put(url, form, { headers: authHeaderJson()});
}

function _delete(id) {
  const url = base_url + model + id;
  axios.interceptors.response.use(handleSuccess, handleError);
  return axios.delete(url, { headers: authHeader()});
}
